import React, { useEffect, useState } from "react";
import { Table, Card, Tag, Switch, Space, Typography } from "antd";
import { EyeOutlined, EyeInvisibleOutlined } from "@ant-design/icons";
import { getAdminVehicles } from "../../api/parkpass/parkpassVehicles";

const { Title } = Typography;

const CitizenVehiclesPage = () => {
  const [vehicles, setVehicles] = useState([]);
  const [loading, setLoading] = useState(false);
  const [includeHidden, setIncludeHidden] = useState(false);
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 25,
    total: 0,
  });

  useEffect(() => {
    fetchVehicles(pagination.current, pagination.pageSize, includeHidden);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [includeHidden]);

  const fetchVehicles = async (page = 1, pageSize = 25, includeHidden = false) => {
    try {
      setLoading(true);
      const response = await getAdminVehicles(page, pageSize, includeHidden);
      setVehicles(response.items);
      setPagination({
        current: response.page,
        pageSize: response.page_size,
        total: response.total,
      });
    } catch (error) {
      console.error("Error fetching vehicles:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleTableChange = (newPagination) => {
    fetchVehicles(newPagination.current, newPagination.pageSize, includeHidden);
  };

  const columns = [
    {
      title: "ID",
      dataIndex: "id",
      key: "id",
      width: 80,
    },
    {
      title: "Plaque d'immatriculation",
      dataIndex: "plate_number",
      key: "plate_number",
      render: (text, record) => (
        <div>
          <div style={{ fontWeight: 500 }}>{text}</div>
          {record.normalized_plate && (
            <div style={{ fontSize: 12, color: "#999" }}>
              {record.normalized_plate}
            </div>
          )}
        </div>
      ),
    },
    {
      title: "Pays",
      dataIndex: "country",
      key: "country",
      width: 100,
      render: (country) => (
        <Tag color="blue">{country || "N/A"}</Tag>
      ),
    },
    {
      title: "Statut",
      dataIndex: "is_hidden",
      key: "is_hidden",
      width: 120,
      render: (isHidden) => (
        <Tag color={isHidden ? "default" : "success"} icon={isHidden ? <EyeInvisibleOutlined /> : <EyeOutlined />}>
          {isHidden ? "Caché" : "Visible"}
        </Tag>
      ),
    },
    {
      title: "Utilisateur",
      key: "user",
      render: (_, record) => (
        <div>
          <div style={{ fontWeight: 500 }}>
            {record.user_full_name || `${record.user_first_name || ""} ${record.user_last_name || ""}`.trim() || "N/A"}
          </div>
          {record.user_email && (
            <div style={{ fontSize: 12, color: "#999" }}>
              {record.user_email}
            </div>
          )}
          {record.user_id && (
            <div style={{ fontSize: 11, color: "#bbb" }}>
              ID: {record.user_id}
            </div>
          )}
        </div>
      ),
    },
    {
      title: "Date de création",
      dataIndex: "created_at",
      key: "created_at",
      width: 160,
      render: (date) => new Date(date).toLocaleString("fr-FR"),
    },
    {
      title: "Dernière modification",
      dataIndex: "updated_at",
      key: "updated_at",
      width: 160,
      render: (date) => new Date(date).toLocaleString("fr-FR"),
    },
  ];

  return (
    <div style={{ padding: 24 }}>
      <Card
        title={
          <Space>
            <Title level={4} style={{ margin: 0 }}>
              Véhicules Citizen
            </Title>
          </Space>
        }
        extra={
          <Space>
            <span>Inclure les cachés:</span>
            <Switch
              checked={includeHidden}
              onChange={(checked) => setIncludeHidden(checked)}
              checkedChildren="ON"
              unCheckedChildren="OFF"
            />
          </Space>
        }
      >
        <Table
          columns={columns}
          dataSource={vehicles}
          rowKey="id"
          loading={loading}
          pagination={{
            ...pagination,
            showSizeChanger: true,
            showTotal: (total) => `Total: ${total} véhicules`,
            pageSizeOptions: ["10", "25", "50", "100"],
          }}
          onChange={handleTableChange}
        />
      </Card>
    </div>
  );
};

export default CitizenVehiclesPage;
